import IconButton from "components/icon-button";
import { useAccordionToggle } from "react-bootstrap";
import { ReactComponent as OutlineChevronDown } from "assets/svg/outline-chevron-down.svg";
import { ReactComponent as OutlineChevronUp } from "assets/svg/outline-chevron-up.svg";

type Props = {
  eventKey: string;
  callback: (arg: string) => void;
  expanded: boolean;
  className: string;
};
const CustomToggle = ({ eventKey, callback, expanded, className }: Props) => {
  const decoratedOnClick = useAccordionToggle(
    eventKey,
    () => callback && callback(eventKey),
  );

  return (
    <IconButton className={className} onClick={decoratedOnClick}>
      {expanded ? <OutlineChevronDown /> : <OutlineChevronUp />}
    </IconButton>
  );
};
export default CustomToggle;
